exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-4cf5d500],h1[data-v-4cf5d500]{text-transform:none}*[data-v-4cf5d500]{font-family:Arial,Helvetica}.label[data-v-4cf5d500]{font-weight:400;font-size:.9rem}", ""]);

// exports
